import { ReactNode } from 'react';
import AuthGuard from './AuthGuard';
import RoleGuard from './RoleGuard';
import { type UserRole } from '../constants';

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles: UserRole[];
  fallbackPath?: string;
}

const ProtectedRoute = ({ children, allowedRoles, fallbackPath = '/dashboard' }: ProtectedRouteProps) => {
  return (
    <AuthGuard>
      <RoleGuard allowedRoles={allowedRoles} fallbackPath={fallbackPath}>
        {children}
      </RoleGuard>
    </AuthGuard>
  );
};

export default ProtectedRoute;
